// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-teaser-try-now__wrapper{width:100%}@media(min-width: 960px){.product-teaser-try-now__wrapper{width:auto}}.product-teaser-try-now__wrapper.hide{display:none}.product-teaser-try-now .loader{position:relative;background:rgba(0,0,0,0);width:auto;height:auto;top:-5px;inset-inline-start:auto}.product-teaser-try-now .aem-button__container{width:100%}", ""]);
// Exports
module.exports = exports;
